var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDenoiser = function SvgDenoiser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.825.097a.609.609 0 1 0-.659 1.024 8.994 8.994 0 0 1 2.699 12.43.609.609 0 1 0 1.024.658c3.05-4.743 1.68-11.061-3.064-14.112"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.822 1.142A7.82 7.82 0 0 0 2 8.965a.609.609 0 1 0 1.218 0 6.604 6.604 0 1 1 11.198 4.745q-.635.614-1.59 1.457a3.89 3.89 0 0 0-1.318 2.917v1.045a3.654 3.654 0 0 1-7.307 0 .609.609 0 1 0-1.217 0 4.871 4.871 0 0 0 9.742 0v-1.046c0-.766.33-1.495.905-2.002a48 48 0 0 0 1.632-1.497A7.822 7.822 0 0 0 9.822 1.142"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.576 7.31a1.856 1.856 0 1 0 0 3.712 1.856 1.856 0 0 0 0-3.712m-.19 1.856a.19.19 0 1 1 .38 0 .19.19 0 0 1-.38 0"
  })));
};
export default SvgDenoiser;